import { render, staticRenderFns } from "./AsyncWorldMap.vue?vue&type=template&id=a64fd852&"
import script from "./AsyncWorldMap.vue?vue&type=script&lang=js&"
export * from "./AsyncWorldMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports